import { Container } from 'inversify'
import { rootContainer } from '~/container'
import { AjaxFetchTopDestinationsRepository } from './AjaxFetchTopDestinationsRepository'
import { TopDestinationsRepository } from './types'

export const container = new Container()
container.parent = rootContainer
container.bind(TopDestinationsRepository).to(AjaxFetchTopDestinationsRepository)
